import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/rn3";
import { toast } from "sonner";
import { useT } from "@/lib/i18n";
import { Mail, ArrowLeft } from "lucide-react";

const Forgot = () => {
  const t = useT();
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot", { email });
      setSubmitted(true);
    } catch {
      // Backend returns 200 regardless to avoid enumeration; treat all as success.
      setSubmitted(true);
    } finally { setBusy(false); }
  };

  if (submitted) {
    return (
      <div className="rn3-container py-20" data-testid="forgot-confirmation">
        <div className="max-w-md mx-auto text-center">
          <Mail className="w-12 h-12 text-[#C4A252] mx-auto" />
          <h1 className="font-serif-display text-4xl mt-4">{t("forgot.check_inbox_title")}</h1>
          <div className="border-t border-[#C4A252] w-12 mx-auto my-5" />
          <p className="text-[#404040]">{t("forgot.check_inbox_body")}</p>
          <Link to="/portal" className="rn3-btn-gold mt-8 inline-flex"><ArrowLeft className="w-4 h-4" /> {t("forgot.back_to_login")}</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="rn3-container py-20" data-testid="forgot-page">
      <div className="max-w-md mx-auto">
        <div className="rn3-eyebrow text-center">{t("forgot.eyebrow")}</div>
        <h1 className="font-serif-display text-4xl mt-3 text-center">{t("forgot.title")}</h1>
        <div className="border-t border-[#C4A252] w-12 mx-auto my-5" />
        <p className="text-sm text-[#404040] text-center mb-6">{t("forgot.intro")}</p>
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <div>
            <label className="rn3-eyebrow block mb-2">{t("forgot.email_label")}</label>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="rn3-input" data-testid="forgot-email" autoFocus />
          </div>
          <button disabled={busy} type="submit" className="rn3-btn-primary w-full justify-center" data-testid="forgot-submit">
            {busy ? "…" : t("forgot.submit")}
          </button>
        </form>
        <div className="mt-6 text-center">
          <Link to="/portal" className="text-xs text-[#737373] underline" data-testid="forgot-back">{t("forgot.back_to_login")}</Link>
        </div>
      </div>
    </div>
  );
};

export default Forgot;
